import { render, staticRenderFns } from "./AdminSubscriptionKeysPage.vue?vue&type=template&id=4a4c6904&scoped=true"
import script from "./AdminSubscriptionKeysPage.vue?vue&type=script&lang=js"
export * from "./AdminSubscriptionKeysPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c6904",
  null
  
)

export default component.exports